export default "__VITE_ASSET__CIYOA_sV__";